import SettingsLayout from "./SettingsLayout";

export default SettingsLayout